import * as React from "react";
import {
  GROUP_TYPE,
  IBroadcastInfo,
  IGroupInfo,
} from "@home-health-notify/domain";
import MuteNotificationsToggle from "./MuteNotificationsToggle";
import VisibleToPatientToggle from "./VisibleToPatientToggle";
import VisibleToPhysicianToggle from "./VisibleToPhysicianToggle";
import HideGroupToggle from "./HideGroupToggle";
import ManageOtherNotifications from "./ManageOtherNotifications";
import LeaveAndDeleteGroup from "./LeaveAndDeleteGroup";
import { SettingsContainer, SettingsTypography } from "./Settings.style";
import { DeleteGroup } from "./DeleteGroup";
import { useTranslation } from "hhn-commons";
import { DrawerDivider } from "../../../layout/RightDrawer.style";

export const Settings = ({
  groupInfo,
}: {
  groupInfo: IGroupInfo | IBroadcastInfo;
}) => {
  const { t } = useTranslation();
  const tNsSettings = (key: string) => t(key, { ns: "settings" });
  const isPatientGroup = groupInfo.groupType === GROUP_TYPE.PATIENT;
  const isBroadcastGroup = groupInfo.groupType === GROUP_TYPE.BROADCAST;
  const isMember = groupInfo.isMember;
  const canDeleteGroup = !isMember || isBroadcastGroup;
  return (
    <>
      {isMember && (groupInfo as IGroupInfo).settings && (
        <SettingsContainer data-testid="settings-component">
          <>
            <SettingsTypography>
              {tNsSettings("groupSettings")}
            </SettingsTypography>

            <MuteNotificationsToggle groupInfo={groupInfo as IGroupInfo} />
            {isPatientGroup && (
              <VisibleToPatientToggle groupInfo={groupInfo as IGroupInfo} />
            )}
            <VisibleToPhysicianToggle groupInfo={groupInfo as IGroupInfo} />
            <HideGroupToggle groupInfo={groupInfo as IGroupInfo} />
            <ManageOtherNotifications groupInfo={groupInfo as IGroupInfo} />
            <LeaveAndDeleteGroup groupInfo={groupInfo as IGroupInfo} />
          </>
        </SettingsContainer>
      )}
      {canDeleteGroup && (
        <>
          {isMember && <DrawerDivider />}
          <DeleteGroup groupInfo={groupInfo} />
          <DrawerDivider />
        </>
      )}
    </>
  );
};
